import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import $ from "jquery";
import { setIsApiLoading, setIsLoading } from "@/store/appSlice";
import { useAppDispatch } from "@/hooks";
import apiClient from "@/utils/api";
import { toast } from "react-toastify";

const ServiceSetting = () => {
  const dispatch = useAppDispatch();
  const [policy, setPolicy] = useState("");
  const [terms, setTerms] = useState("");
  const [isMaintenance, setIsMaintenance] = useState(false);

  const fetchPolicy = async () => {
    dispatch(setIsApiLoading(true));
    try {
      const response = await apiClient.get(`policy`);
      const { data } = response.data;
      setPolicy(data);
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setIsApiLoading(false));
    }
  };

  const fetchTerms = async () => {
    dispatch(setIsApiLoading(true));
    try {
      const response = await apiClient.get(`terms`);
      const { data } = response.data;
      setTerms(data);
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setIsApiLoading(false));
    }
  };

  const fetchMaintenanceStatus = async () => {
    dispatch(setIsApiLoading(true));
    try {
      const response = await apiClient.get(`maintenance-status`);
      const { data } = response.data;
      setIsMaintenance(data?.isMaintenance);
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setIsApiLoading(false));
    }
  };

  useEffect(() => {
    fetchPolicy();
    fetchTerms();
    fetchMaintenanceStatus();
  }, []);

  useEffect(() => {
    $("#switch").on("click", function () {
      if (window.confirm("メンテナンスモードを変更します、よろしでしょか？")) {
        $(this).toggleClass("on");
        const label = $(this).hasClass("on") ? "ON" : "OFF";
        $(this).find(".label").text(label);
        const maintenanceStatus = $(this).hasClass("on") ? true : false;
        updateMaintenanceStatus(maintenanceStatus);
        setIsMaintenance(maintenanceStatus);
      }
    });

    return () => {
      $("#switch").off("click");
    };
  }, []);

  function execCmd(command, value = null) {
    document.execCommand(command, false, value);
    updateToolbar();
  }

  function updateToolbar() {
    document
      .getElementById("bold")
      .classList.toggle("active", document.queryCommandState("bold"));
    document
      .getElementById("italic")
      .classList.toggle("active", document.queryCommandState("italic"));
    document
      .getElementById("underline")
      .classList.toggle("active", document.queryCommandState("underline"));
    // Add more toolbar button updates here if needed
  }

  useEffect(() => {
    const termsEditor = document.getElementById("terms-editor");
    const policyEditor = document.getElementById("policy-editor");
    const updateToolbarHandler = () => {
      updateToolbar();
    };
    termsEditor.addEventListener("input", updateToolbarHandler);
    termsEditor.addEventListener("click", updateToolbarHandler);
    termsEditor.addEventListener("keyup", updateToolbarHandler);
    policyEditor.addEventListener("input", updateToolbarHandler);
    policyEditor.addEventListener("click", updateToolbarHandler);
    policyEditor.addEventListener("keyup", updateToolbarHandler);
    return () => {
      termsEditor.removeEventListener("input", updateToolbarHandler);
      termsEditor.removeEventListener("click", updateToolbarHandler);
      termsEditor.removeEventListener("keyup", updateToolbarHandler);
      policyEditor.removeEventListener("input", updateToolbarHandler);
      policyEditor.removeEventListener("click", updateToolbarHandler);
      policyEditor.removeEventListener("keyup", updateToolbarHandler);
    };
  }, []);

  const updateTerms = async () => {
    dispatch(setIsApiLoading(true));
    try {
      const editorContent = document.getElementById("terms-editor").innerHTML;
      await apiClient.put(`terms`, { content: editorContent });
      toast.success("利用規約が変更されました。");
      document
        .querySelector<HTMLButtonElement>(
          "#popupTerms > div > div > div.modal-header > button"
        )
        ?.click();
      fetchTerms();
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setIsApiLoading(false));
    }
  };

  const updatePolicy = async () => {
    dispatch(setIsApiLoading(true));
    try {
      const editorContent = document.getElementById("policy-editor").innerHTML;
      await apiClient.put(`policy`, { content: editorContent });
      toast.success("プライバシーポリシーが変更されました。");
      document
        .querySelector<HTMLButtonElement>(
          "#popupPolicy > div > div > div.modal-header > button"
        )
        ?.click();
      fetchPolicy();
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setIsApiLoading(false));
    }
  };

  const updateMaintenanceStatus = async (isMaintenance) => {
    try {
      dispatch(setIsApiLoading(true));
      await apiClient.put(`maintenance-status`, { isMaintenance });
      toast.success("メンテナンスモードが変更されました。");
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setIsApiLoading(false));
    }
  };

  return (
    <>
      <Helmet>
        <title>サービス管理</title>
      </Helmet>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="service_setting">
                  <div className="groupItem">
                    <label>利用規約</label>
                    <button
                      className="btn btn-danger btnInfo"
                      data-bs-toggle="modal"
                      data-bs-target="#popupTerms"
                    >
                      編集
                    </button>
                  </div>
                  <div className="groupItem">
                    <label>プライバシーポリシー</label>
                    <button
                      className="btn btn-danger btnInfo"
                      data-bs-toggle="modal"
                      data-bs-target="#popupPolicy"
                    >
                      編集
                    </button>
                  </div>
                  <div className="groupItem">
                    <label>メンテナンスモード</label>
                    <div
                      id="switch"
                      className={`switch ${isMaintenance ? "on" : ""}`}
                    >
                      <div className="knob"></div>
                      <span className="label">
                        {isMaintenance ? "ON" : "OFF"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="popupTerms">
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">利用規約編集</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <div className="forMeEditor">
                <div className="toolbar">
                  <button id="undo" onClick={() => execCmd("undo")}></button>
                  <button id="redo" onClick={() => execCmd("redo")}></button>
                  <select
                    id="Paragraph"
                    onChange={(e) => execCmd("formatBlock", e.target.value)}
                  >
                    <option value="P">Paragraph</option>
                    <option value="H1">Heading 1</option>
                    <option value="H2">Heading 2</option>
                    <option value="H3">Heading 3</option>
                    <option value="H4">Heading 4</option>
                    <option value="H5">Heading 5</option>
                    <option value="H6">Heading 6</option>
                  </select>
                  <button id="bold" onClick={() => execCmd("bold")}>
                    <b>B</b>
                  </button>
                  <button id="italic" onClick={() => execCmd("italic")}>
                    <i>I</i>
                  </button>
                  <button id="underline" onClick={() => execCmd("underline")}>
                    <u>U</u>
                  </button>
                  <button
                    id="justifyLeft"
                    onClick={() => execCmd("justifyLeft")}
                  ></button>
                  <button
                    id="justifyCenter"
                    onClick={() => execCmd("justifyCenter")}
                  ></button>
                  <button
                    id="justifyRight"
                    onClick={() => execCmd("justifyRight")}
                  ></button>
                  <button
                    id="justifyFull"
                    onClick={() => execCmd("justifyFull")}
                  ></button>
                  <button
                    id="insertUnorderedList"
                    onClick={() => execCmd("insertUnorderedList")}
                  ></button>
                  <button
                    id="insertOrderedList"
                    onClick={() => execCmd("insertOrderedList")}
                  ></button>
                  <button
                    id="createLink"
                    onClick={() =>
                      execCmd("createLink", prompt("Enter URL:", "http://"))
                    }
                  ></button>
                </div>
                <div className="editor-container">
                  <div
                    id="terms-editor"
                    className="editor"
                    contentEditable="true"
                    data-placeholder="Say something..."
                    dangerouslySetInnerHTML={{ __html: terms }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button onClick={updateTerms} className="btn btn-success">
                保存
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="popupPolicy">
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">利用規約編集</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <div className="forMeEditor">
                <div className="toolbar">
                  <button id="undo" onClick={() => execCmd("undo")}></button>
                  <button id="redo" onClick={() => execCmd("redo")}></button>
                  <select
                    id="Paragraph"
                    onChange={(e) => execCmd("formatBlock", e.target.value)}
                  >
                    <option value="P">Paragraph</option>
                    <option value="H1">Heading 1</option>
                    <option value="H2">Heading 2</option>
                    <option value="H3">Heading 3</option>
                    <option value="H4">Heading 4</option>
                    <option value="H5">Heading 5</option>
                    <option value="H6">Heading 6</option>
                  </select>
                  <button id="bold" onClick={() => execCmd("bold")}>
                    <b>B</b>
                  </button>
                  <button id="italic" onClick={() => execCmd("italic")}>
                    <i>I</i>
                  </button>
                  <button id="underline" onClick={() => execCmd("underline")}>
                    <u>U</u>
                  </button>
                  <button
                    id="justifyLeft"
                    onClick={() => execCmd("justifyLeft")}
                  ></button>
                  <button
                    id="justifyCenter"
                    onClick={() => execCmd("justifyCenter")}
                  ></button>
                  <button
                    id="justifyRight"
                    onClick={() => execCmd("justifyRight")}
                  ></button>
                  <button
                    id="justifyFull"
                    onClick={() => execCmd("justifyFull")}
                  ></button>
                  <button
                    id="insertUnorderedList"
                    onClick={() => execCmd("insertUnorderedList")}
                  ></button>
                  <button
                    id="insertOrderedList"
                    onClick={() => execCmd("insertOrderedList")}
                  ></button>
                  <button
                    id="createLink"
                    onClick={() =>
                      execCmd("createLink", prompt("Enter URL:", "http://"))
                    }
                  ></button>
                </div>
                <div className="editor-container">
                  <div
                    id="policy-editor"
                    className="editor"
                    contentEditable="true"
                    data-placeholder="Say something..."
                    dangerouslySetInnerHTML={{ __html: policy }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button onClick={updatePolicy} className="btn btn-success">
                保存
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceSetting;
